import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { putGroupSignUp3 } from "../../api/signin";
import ButtonNextLevel from "./buttonNextLevel";
import CheckboxEquipment from "./checkboxEquipment";
import SelectInput from "./selectInput";

export default function SigninEquipment({
  setLevel,
  level,
  setDataForm,
  dataForm,
  update,
}) {
  const [densityUnitCount, setDensityUnitCount] = useState(0);
  const [densityUnitCountFinal, setDensityUnitCountFinal] = useState();

  useEffect(() => {
    if (densityUnitCount === "1 تا 5 عدد") setDensityUnitCountFinal("BELOW_5");
    if (densityUnitCount === "6 تا 10 عدد")
      setDensityUnitCountFinal("BELOW_10");
    if (densityUnitCount === "بیش از 10 عدد")
      setDensityUnitCountFinal("ABOVE_10");
    if (densityUnitCount === "قرضی از دیگر گروه ها")
      setDensityUnitCountFinal("BORROWED");
  }, [densityUnitCount]);
  useEffect(() => {
    if (densityUnitCountFinal) {
      setDataForm({ ...dataForm, densityUnitCount: densityUnitCountFinal });
    }
  }, [densityUnitCountFinal]);
  useEffect(() => {
    if (dataForm?.densityUnitCount === "BELOW_5")
      setDensityUnitCount("1 تا 5 عدد");
    if (dataForm?.densityUnitCount === "BELOW_10")
      setDensityUnitCount("6 تا 10 عدد");
    if (dataForm?.densityUnitCount === "ABOVE_10")
      setDensityUnitCount("بیش از 10 عدد");
    if (dataForm?.densityUnitCount === "BORROWED")
      setDensityUnitCount("قرضی از دیگر گروه ها");
  }, [dataForm?.densityUnitCount]);
  return (
    <>
      <Box mb="50px" display={"flex"} gap="100px" width="100%">
        <Box width="70%">
          <Typography color="#126E83" fontSize="20px">
            {"تجهیزات دندان پزشکی"}
          </Typography>
          <Typography mt="20px" className="styleLabel">
            {"تعداد یونیت های دندانپزشکی"}
          </Typography>
          <SelectInput
            value={densityUnitCount}
            setValue={setDensityUnitCount}
            width="430px"
            data={[
              "1 تا 5 عدد",
              "6 تا 10 عدد",
              "بیش از 10 عدد",
              "قرضی از دیگر گروه ها",
            ]}
            placeholder="انتخاب کنید"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                restorationToothCount: Number(
                  e.target.value.replace(/\D/g, "")
                ),
              })
            }
            value={dataForm.restorationToothCount}
            label="تجهیزات ترمیم"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                rooterCanalCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.rooterCanalCount}
            label="تجهیزات عصب کشی"
          />
        </Box>
        <Box width="90%" mt="60px">
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                pullToothCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.pullToothCount}
            label="تجهیزات کشیدن"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                imagingEquipmentCount: Number(
                  e.target.value.replace(/\D/g, "")
                ),
              })
            }
            value={dataForm.imagingEquipmentCount}
            label="تجهیزات تصویربرداری"
          />
        </Box>
      </Box>
      <Box mb="50px" display={"flex"} gap="100px" width="100%">
        <Box width="80%">
          <Typography color="#126E83" fontSize="20px">
            {"تجهیزات پزشکی"}
          </Typography>

          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                barometerCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.barometerCount}
            label="کاف فشارسنج"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                paravanCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.paravanCount}
            label="پاراوان"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                examinationSetCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.examinationSetCount}
            label="ست معاینه پزشکی"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                ecgCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.ecgCount}
            label="نوار قلب"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                revivingBagCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.revivingBagCount}
            label="کیف احیا و تریال اورژانس"
          />
        </Box>
        <Box width="100%" mt="30px">
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                glucometerCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.glucometerCount}
            label="گلوکومتر"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                bedCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.bedCount}
            label="تخت"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                monitoringCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.monitoringCount}
            label="مونیتورینگ"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                electronicShockCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.electronicShockCount}
            label="الکتروشوک"
          />
        </Box>
      </Box>
      <Box mb="50px" display={"flex"} gap="100px" width="100%">
        <Box width="80%">
          <Typography color="#126E83" fontSize="20px">
            {"ست تجهیزات زنان و مامایی"}
          </Typography>

          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                popEsmirCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.popEsmirCount}
            label="پاپ اسمیر"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                wifeExaminationEquipmentCount: Number(
                  e.target.value.replace(/\D/g, "")
                ),
              })
            }
            value={dataForm.wifeExaminationEquipmentCount}
            label="تجهیزات معاینه زنان"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                geneticallyBedCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.geneticallyBedCount}
            label="تخت ژنیکولوژی"
          />
        </Box>
        <Box width="100%" mt="30px">
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                sonoKidCount: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.sonoKidCount}
            label="سونوکید"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                samplingEquipmentCount: Number(
                  e.target.value.replace(/\D/g, "")
                ),
              })
            }
            value={dataForm.samplingEquipmentCount}
            label="تجهیزات نمونه برداری"
          />
        </Box>
      </Box>
      <Box mb="50px" display={"flex"} gap="100px" width="100%">
        <Box width="80%">
          <Typography color="#126E83" fontSize="20px">
            {"ست تجهیزات چشم و بینایی سنجی"}
          </Typography>

          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                optometryEquip1: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.optometryEquip1}
            label="تجهیزات غربالگری اولیه"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                optometryEquip3: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.optometryEquip3}
            label="اسلیت لمپ"
          />
        </Box>
        <Box width="100%" mt="30px">
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                optometryEquip2: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.optometryEquip2}
            label="اتورفرکتومتر"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                optometryEquip4: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.optometryEquip4}
            label="تجهیزات تجویز(رتینوسکوپ جعبه لنز)"
          />
        </Box>
      </Box>
      <Box mb="50px" display={"flex"} gap="100px" width="100%">
        <Box width="80%">
          <Typography color="#126E83" fontSize="20px">
            {"ست تجهیزات گوش و سنوایی سنجی"}
          </Typography>

          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                audiologistEquip1: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.audiologistEquip1}
            label="تجهیزات اتوسکوپی و معاینه تخصصی گوش و حلق و بینی"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                audiologistEquip3: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.audiologistEquip3}
            label="ساکشن"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                audiologistEquip5: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.audiologistEquip5}
            label="تیمپانومتری"
          />
        </Box>
        <Box width="100%" mt="30px">
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                audiologistEquip2: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.audiologistEquip2}
            label="ادیتومتری غربالگری"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                audiologistEquip4: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.audiologistEquip4}
            label="ادیتومتری تشخیص و OAE و ..."
          />
        </Box>
      </Box>
      <Box mb="50px" display={"flex"} gap="100px" width="100%">
        <Box width="80%">
          <Typography color="#126E83" fontSize="20px">
            {"ست تجهیزات تصویربرداری"}
          </Typography>

          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                imagingEquip1: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.imagingEquip1}
            label="ماموگرافی"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                imagingEquip3: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.imagingEquip3}
            label="سونوگرافی و اکوکاردیوگرافی"
          />
        </Box>
        <Box width="100%" mt="30px">
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                imagingEquip2: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.imagingEquip2}
            label="رادیوگرافی"
          />
        </Box>
      </Box>
      <Box mb="50px" display={"flex"} gap="100px" width="100%">
        <Box width="80%">
          <Typography color="#126E83" fontSize="20px">
            {"ست تجهیزات آزمایشگاه"}
          </Typography>

          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                laboratoryEquip1: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.laboratoryEquip1}
            label="میکروسکوپی"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                laboratoryEquip3: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.laboratoryEquip3}
            label="هورمونی"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                laboratoryEquip5: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.laboratoryEquip5}
            label="CBC"
          />
        </Box>
        <Box width="100%" mt="30px">
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                laboratoryEquip2: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.laboratoryEquip2}
            label="UA"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                laboratoryEquip4: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.laboratoryEquip4}
            label="بیوشیمی"
          />
        </Box>
      </Box>
      <Box mb="50px" display={"flex"} gap="100px" width="100%">
        <Box width="80%">
          <Typography color="#126E83" fontSize="20px">
            {"ست تجهیزات رسانه‌ای"}
          </Typography>

          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                mediaEquip1: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.mediaEquip1}
            label="میکروفون حرفه‌ای"
          />
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                mediaEquip3: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.mediaEquip3}
            label="دوربین عکاسی"
          />
        </Box>
        <Box width="100%" mt="30px">
          <CheckboxEquipment
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                mediaEquip2: Number(e.target.value.replace(/\D/g, "")),
              })
            }
            value={dataForm.mediaEquip2}
            label="استودیو"
          />
        </Box>
      </Box>
      <Box mb="50px" display={"flex"} gap="100px" width="100%">
        <Box width="80%">
          <Typography color="#126E83" fontSize="20px">
            {"دیگر تجهیزات"}
          </Typography>

          <CheckboxEquipment dinamic />
          <CheckboxEquipment dinamic />
        </Box>
        <Box width="100%" mt="30px">
          <CheckboxEquipment dinamic />
          <CheckboxEquipment dinamic />
          <ButtonNextLevel
            onClickNextLevel={() => {
              if (update) {
                setLevel(4);
              } else {
                putGroupSignUp3(dataForm)
                  .then(() => setLevel(4))
                  .catch((err) => {
                    // toast.error(err.data)
                  });
              }
            }}
            justifyContent="end"
            level={level}
            setLevel={setLevel}
          />
        </Box>
      </Box>
    </>
  );
}
